import React from 'react';
import Icon from '../../../bootstrap/components/icon/Icon';

export default function AudioIcon() {
    return <Icon name="headphones"/>;   
}
